export default __webpack_public_path__ + "static/media/philipp.39072c5c.jpeg";